import React, { ReactNode, useMemo } from 'react';
import { getTheme } from './Theme';
import customUseTheme from '../customHooks/useTheme';
import { ThemeProvider } from '@mui/material';

interface ThemeWrapperProps {
    children: ReactNode;
}

const ThemeWrapper = ({ children }: ThemeWrapperProps) => {
    const { theme } = customUseTheme();
    const muiTheme = useMemo(() => getTheme(theme), [theme]);

    return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>;
};

export default ThemeWrapper;
